import React from 'react';
import './Features.css';

// Import icons
import characterIcon from '../../static/how_it_works_character.svg';
import setIcon from '../../static/how_it_works_set.svg';
import storyIcon from '../../static/how_it_works_story.svg';

const Features = () => {
  return (
    <section className="how-it-works-section">
      <div className="how-it-works-content">
        <div className="how-it-works-title">
          <div className="how-it-works-subtitle">How It Works</div>
          <h2>How ChildStoryTime.ai Works</h2>
        </div>
        
        <div className="steps-container">
          {/* Dashed line connecting steps */}
          <div className="dashed-line-container">
            <svg width="100%" height="100" viewBox="0 0 1836 372" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
              <path d="M5.50015 371.5C-16.3332 253.667 28.6935 77.7 357.493 86.5C495.395 90.1908 578.372 85.1586 620.979 65.8267C679.063 39.4727 598.049 -22.9657 564.266 31.1359C547.502 57.9823 540.114 92.7913 553.984 130.633C578.302 196.978 667.259 191.386 727.086 153.786C890.66 50.9858 1167.19 -78.7487 1345.49 68.5C1586 236 1771 169.5 1836 97.5" 
                stroke="black" strokeOpacity="0.16" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeDasharray="10 10"/>
            </svg>
          </div>
          
          <div className="step">
            <div className="step-icon-container">
              <div className="step-bg">
                <svg width="136" height="136" viewBox="0 0 136 136" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.69547 104.874C-14.2738 62.3112 15.9327 32.4073 34.2411 15.8959C73.9093 -19.8787 87.3333 12.2267 123.033 38.8284C151.593 60.1096 126.39 95.395 110.218 110.378C105.897 114.058 98.2421 120.436 93.3604 124.107C90.6764 126.125 87.7351 127.785 84.6983 129.219C65.0007 138.518 28.0043 144.22 7.69547 104.874Z" fill="#3180F5"/>
                </svg>
              </div>
              <div className="step-icon">
                <img src={characterIcon} alt="Character icon" />
              </div>
            </div>
            <h3>Choose a Character</h3>
            <p>Let your child pick their favorite hero, animal, or magical creature!</p>
          </div>
          
          <div className="step">
            <div className="step-icon-container">
              <div className="step-bg">
                <svg width="117" height="129" viewBox="0 0 117 129" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 54.7015C-0.000307568 111.644 34.6353 127.609 53.7758 128.521C73.5239 131.255 113.749 123.599 116.666 71.1058C118.659 35.2268 111.399 16.0371 103.79 6.902C98.5631 0.626838 89.7633 0.0165511 81.5965 0.00404593C22.4396 -0.0865364 0.0002908 0.86398 0 54.7015Z" fill="#FF7B1C"/>
                </svg>
              </div>
              <div className="step-icon">
                <img src={setIcon} alt="Adventure icon" />
              </div>
            </div>
            <h3>Set the Adventure</h3>
            <p>Select a setting and theme: jungle, space, fairyland, and more!</p>
          </div>
          
          <div className="step">
            <div className="step-icon-container">
              <div className="step-bg">
                <svg width="129" height="119" viewBox="0 0 129 119" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M127.959 40.4251C126.637 4.43049 92.4501 0.918808 75.1497 0H75.1495C59.6722 4.33717e-05 29.0789 0.000127792 12.326 22.0501C-8.61521 49.6126 -9.5257 113.925 63.3134 118.519C136.152 123.113 129.95 94.6315 127.959 40.4251Z" fill="#E249EE"/>
                </svg>
              </div>
              <div className="step-icon">
                <img src={storyIcon} alt="Story icon" />
              </div>
            </div>
            <h3>Enjoy the Story!</h3>
            <p>Our AI weaves a fun, age-appropriate story in seconds.</p>
          </div>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="decorative-elements">
        {/* Colored dots */}
        <div className="decorative-dot blue"></div>
        <div className="decorative-dot purple"></div>
        <div className="decorative-dot orange"></div>
        <div className="decorative-dot small-purple"></div>
        
        {/* Star */}
        <div className="star">
          <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1_89447)">
              <path d="M41.7084 14.8391C41.8385 14.9692 41.8668 15.1502 41.7735 15.3058L34.6232 26.5743L40.5573 27.9036C40.7298 27.946 40.8543 28.1044 40.8599 28.2741C40.8514 28.3788 40.8118 28.4636 40.7383 28.5372C40.6874 28.5881 40.6252 28.622 40.5601 28.6418L34.6204 29.9712L41.7622 41.2368C41.8583 41.3839 41.8329 41.5847 41.7084 41.7092C41.584 41.8336 41.3832 41.8534 41.2361 41.7573L29.9761 34.6098L28.6468 40.5495C28.627 40.6202 28.593 40.6824 28.5393 40.7362C28.4686 40.8069 28.3809 40.8493 28.2762 40.8465C28.1009 40.8522 27.9425 40.7277 27.8944 40.5552L26.5792 34.6126L15.3136 41.7601C15.2409 41.8084 15.1536 41.8298 15.0668 41.8205C14.98 41.8112 14.8992 41.7718 14.8384 41.7092C14.7111 41.5819 14.6885 41.3896 14.7846 41.2312L21.9293 29.9627L16.0009 28.6447C15.9152 28.6272 15.8383 28.5803 15.7836 28.5121C15.7288 28.4439 15.6996 28.3587 15.7011 28.2713C15.7011 28.0903 15.8198 27.9432 15.9952 27.898L21.9377 26.5714L14.7875 15.3086C14.5951 14.9975 15.0109 14.5817 15.3136 14.7825L26.582 21.9271L27.9085 15.9846C27.9425 15.8206 28.0924 15.699 28.2791 15.6933C28.4488 15.6933 28.6043 15.8206 28.6496 15.9959L29.9761 21.9271L41.2417 14.7741C41.3973 14.6807 41.5812 14.7118 41.7084 14.8391Z" fill="#6F2ECA"/>
            </g>
            <defs>
              <clipPath id="clip0_1_89447">
                <rect width="40" height="40" fill="white" transform="translate(0 28.2843) rotate(-45)"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        
        {/* Heart */}
        <div className="heart">
          <svg width="46" height="60" viewBox="0 0 46 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32.7889 2.05947C29.6428 0.963529 25.8767 1.8504 24.1196 4.2704L23.9563 4.50902C22.8483 6.22633 22.6721 8.47445 22.83 10.9294L22.8658 11.4229C23.3017 16.8003 24.7184 22.0446 27.0468 26.899L29.2667 31.5273L24.9042 28.8228C23.2898 27.8219 21.5138 26.4882 19.7862 25.2667C18.0151 24.0144 16.2343 22.8325 14.4501 21.9853C12.6661 21.1381 10.9753 20.6732 9.37613 20.7516C7.91614 20.8231 6.41872 21.3521 4.89079 22.6702L4.58483 22.945C2.39348 24.9831 1.45519 28.3905 2.03319 31.3926L2.09347 31.6826C2.86694 35.0816 5.12972 37.6875 8.13841 39.8714C10.4101 41.5204 13.0075 42.8604 15.553 44.0908L18.0664 45.2918C25.4816 48.8353 33.5677 52.1396 40.8598 56.5094C41.079 53.0106 41.5362 49.5477 42.0392 46.1285C42.591 42.3779 43.1921 38.7042 43.6158 35.0154L43.786 33.4332C44.6008 25.2604 44.2568 16.9033 40.7128 9.9247L40.3601 9.25328C38.6319 6.08101 36.1825 3.36181 33.0909 2.17041L32.7889 2.05947Z" stroke="#F74A6A" strokeWidth="3"/>
          </svg>
        </div>
        
        {/* Wave */}
        <div className="wave">
          <svg width="119" height="18" viewBox="0 0 119 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 15.5455H17.6853C21.7223 15.5455 25.6963 14.5442 29.2515 12.6314L34.8445 9.62221C39.6832 7.01882 45.5855 7.41726 50.0304 10.6474V10.6474C55.2031 14.4064 62.2424 14.2756 67.2719 10.3269L69.1124 8.88197C75.0058 4.25511 83.298 4.25511 89.1914 8.88197V8.88197C95.2224 13.6169 103.742 13.4943 109.634 8.58793L117 2.45455" stroke="#FF7B1C" strokeWidth="3" strokeLinecap="round"/>
          </svg>
        </div>
        
        {/* Squiggle */}
        <div className="squiggle">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" preserveAspectRatio="xMidYMid meet">
            <g>
              <path d="M41.03 18.11C42.34 27.6 35.66 37.46 36.57 47" stroke="#FF7B1C" strokeWidth="4" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M23.06 25.41C27.89 35.14 34.28 43.9 40.04 53.06" stroke="#FF7B1C" strokeWidth="4" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M11.73 42.81C20.42 45.54 27.48 59.51 36.59 59.19" stroke="#FF7B1C" strokeWidth="4" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Features;